import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  seeAdvicesView: {
  },
  listRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonView: {
    textAlign: 'right',
    paddingTop: 20,
  },
  advicesCheckbox: {
    height: 18,
    width: 18,
    marginHorizontal: 10,
  },
  docNameRead: {
    paddingLeft: 5,
    color: PALETTE.secondaryActive,
  },
  docNameUnRead: {
    paddingLeft: 5,
    color: PALETTE.primaryActive,
  },
  rowFooter: {
    paddingLeft: 45,
    color: '#a7a8aa',
    flex: 1
  },
  pdfView: {
    flex: 0.2,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'left'
  },
  notAllowedCursor:{
    cursor: 'not-allowed',
  },
  pointerCursor:{
    cursor: 'pointer',
  },
  checkboxRow: {
    flex:1,
    height: 65,
    marginTop: 20,
    flexDirection: 'row',
    justifyContent: "center",
    alignItems: 'center',
    paddingLeft: 15,
  },
  selectAllCheckbox: {
    flex:1,

    marginTop: 20,
    marginBottom: 20,
    flexDirection: 'row',
    paddingLeft: 15,
    alignItems: "center",
  },
  rowHeader: {
    color: PALETTE.primaryActive,
    paddingLeft: 20,
  },
  checkedItem: {
    color: PALETTE.primaryActive,
  },
  uncheckedItem: {
    color: PALETTE.uncheckItemColor,
  },
});
